import type { FC } from 'react';
import { useTheme } from 'styled-components';
import type { IIconsProps } from './types';
import { IconScale } from './types';

const Discounts: FC<IIconsProps> = ({
  color,
  size = IconScale.M,
}: IIconsProps) => {
  const theme = useTheme();
  if (!color) {
    color = theme.palette.primary.main;
  }
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="19.2834"
        y="3.44458"
        width="2"
        height="22.3997"
        rx="1"
        transform="rotate(45 19.2834 3.44458)"
        fill={color}
      />
      <circle cx="7" cy="7" r="3" stroke={color} strokeWidth="2" />
      <circle cx="17" cy="17" r="3" stroke={color} strokeWidth="2" />
    </svg>
  );
};

export default Discounts;
